import emptySliceApi from '../../../../../shared/store/emptyApiSlice';
import { UserQueryResult } from '../../../../../shared/models/UserModels';

export interface GetQueryUsersProp {
  accountId: string;
  page: number;
  pageSize: number;
  keyword: string;
  dealIds?: string[];
  productSkus?: string[];
  statuses: string[];
  sortField?: string;
  sortOrder?: string;
}

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    getUsers: builder.query<UserQueryResult, GetQueryUsersProp>({
      query: ({
        accountId,
        page,
        pageSize,
        keyword,
        dealIds = [],
        productSkus = [],
        statuses = [],
        sortField = '',
        sortOrder = '',
      }: GetQueryUsersProp) => ({
        url: `v4/accounts/${accountId}/users`,
        method: 'POST',
        body: {
          page,
          pageSize,
          search: keyword,
          dealIds,
          productSkus,
          statuses,
          sortField,
          sortOrder,
        },
      }),
      providesTags: ['User'],
    }),
    resendUserInvitation: builder.mutation<any, { accountUserId: string }>({
      query: ({ accountUserId }) => ({
        url: `v4/accounts/users/invites/${accountUserId}/resend`,
        method: 'POST',
      }),
      invalidatesTags: ['User'],
    }),
  }),
});

export const { useGetUsersQuery, useResendUserInvitationMutation } = apiSlice;
